import { IKlangooNLPConfig } from '../../services/common/nlp/klangoo-config'
import { PageType } from '../../services/common/page-types'
import { Entity } from '../entity'

export interface IDate {
    mod?: Date
    pub?: Date
}

export interface IVideo {
    ids: string[]
    inPage: boolean
}

export interface ITitle {
    alt?: string
    main?: string
}

export interface IPageConfiguration {
    ancestry?: string[]
    articleId?: string
    authors?: string[]
    date?: IDate
    dist?: string
    error?: number
    excerpt?: string
    isOrigin?: boolean
    klangoo?: IKlangooNLPConfig
    kw?: string[]
    originId?: string
    paywall?: string
    slug?: string
    sponsor?: string
    tags?: string[]
    title?: ITitle
    type: PageType
    video?: IVideo
    wc?: number
}

export class PageConfiguration extends Entity implements IPageConfiguration {
    public ancestry?: string[]
    public articleId?: string
    public authors?: string[]
    public date?: IDate
    public dist?: string
    public error?: number
    public excerpt?: string
    public isOrigin?: boolean
    public klangoo?: IKlangooNLPConfig
    public kw?: string[]
    public originId?: string
    public paywall?: string
    public slug?: string
    public sponsor?: string
    public tags?: string[]
    public title?: ITitle
    public type: PageType
    public video?: IVideo
    public wc?: number

    public fromJson(jsonObject: object): IPageConfiguration {
        super.fromJson(jsonObject)

        // parse date
        if ((jsonObject as this).date) {
            this.date = {}
            if ((jsonObject as this).date.mod) {
                this.date.mod = new Date(Date.parse((jsonObject as any).date.mod))
            }
            if ((jsonObject as this).date.pub) {
                this.date.pub = new Date(Date.parse((jsonObject as any).date.pub))
            }
        }

        // parse Klangoo
        if ((jsonObject as this).klangoo) {
            this.klangoo = (jsonObject as this).klangoo
        }

        // parse title
        if ((jsonObject as this).title) {
            this.title = (jsonObject as this).title
        }

        // parse video
        if ((jsonObject as this).video) {
            this.video = (jsonObject as this).video
        }

        return this
    }
}
